const searchInput = document.getElementById('search-input');
const collectionContainer = document.getElementById('collection-container');

if (searchInput && collectionContainer) {
  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.trim().toLowerCase();
    const products = collectionContainer.querySelectorAll('.product');

    products.forEach((product) => {
      if (product.contains(query, 'metafield=model')) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  });
}


